export default function getFormattedStockAmount(stock: number | undefined) {
	if (stock && stock > 100) {
		return '100+';
	}
	return stock?.toString();
}
